import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { LinkComponentType, MainContext, NavigationContextProvider } from '@restworld/utils-common';
import { AuthFlowModals } from './auth-flow-modals';
import { GlobalJobPositionPreferencesModal } from './global-job-position-preferences-modal';
import WorkerEntryPointModal from '../components/worker-entry-point/worker-entry-point-modal';

export const MainContextWrapper = ({ children }: { children: React.ReactNode }) => (
  <NavigationProviderWrapper>
    <MainContext>
      {children}
      <AuthFlowModals />
      {/* Entry point for screens that do not mount one themselves, the login page
          and the login modal above. It sits beside AuthFlowModals rather than
          inside the login form because opening it closes that form, which would
          take the modal down with it. Renders nothing until
          `openStandaloneUploadCvEntryPoint` is fired. */}
      <WorkerEntryPointModal standalone />
      <GlobalJobPositionPreferencesModal />
    </MainContext>
  </NavigationProviderWrapper>
);
const NavigationProviderWrapper = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  return (
    <NavigationContextProvider linkComponent={Link as LinkComponentType} router={router}>
      {children}
    </NavigationContextProvider>
  );
};
